import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { AppService } from "src/app/core/services/app.service";
import { OOVenueService } from "src/app/core/services/venue-service";
import { Invoice } from "src/app/shared/models/DTO/VenueFinance.dto";

@Component({
	selector: "app-invoice-record",
	templateUrl: "./invoice-record.component.html",
	styleUrls: ["../../../commandcenter.scss"],
})
export class InvoiceRecordComponent implements OnInit {
	@Input() invoice: Invoice;
	@Output() invoiceChange = new EventEmitter<Invoice>();

	constructor(public app: AppService, public venueService: OOVenueService) {}

	ngOnInit(): void {}

	initInvoicePay() {
		window.open(this.invoice.paymentUrl, "_blank");
	}
}
